import axios from 'axios'
import { Store } from 'vuex'
import VueRouter from 'vue-router'
import { LS_KEY_SELECTED } from '@/shared/config/store/marketplace-store'
import { Account } from '@/shared/model/account.model'
import { Marketplace } from '@/shared/enums/marketplace'

export default class AccountService {
  constructor (private store: Store<any>, private router: VueRouter) {
    this.init()
  }

  public init (): void {
    this.retrieveAccount()
    this.retrieveProfiles()
  }

  public retrieveProfiles (): void {
    axios.get('management/info').then(res => {
      if (res.data && res.data.activeProfiles) {
        this.store.commit('setActiveProfiles', res.data['activeProfiles'])
      }
    })
  }

  public retrieveAccount (): void {
    this.store.commit('authenticate')
    axios
      .get('api/account')
      .then(response => {
        const account: Account = response.data
        if (account) {
          this.store.commit('authenticated', account)
          if (account.marketplaces) {
            // Select one by default, can be changed by the user
            let selectedMarketplace = window.localStorage.getItem(LS_KEY_SELECTED)
            if (!selectedMarketplace || !account.marketplaces.includes(selectedMarketplace as Marketplace)) {
              selectedMarketplace = account.marketplaces[0]
              window.localStorage.setItem(LS_KEY_SELECTED, selectedMarketplace)
            }
            this.store.commit('selectMarketplace', selectedMarketplace)
          }
          if (sessionStorage.getItem('requested-url')) {
            this.router.replace(sessionStorage.getItem('requested-url'))
            sessionStorage.removeItem('requested-url')
          }
        } else {
          this.router.push('/')
          sessionStorage.removeItem('requested-url')
        }
      })
      .catch(error => {
        if (error.response) {
          switch (error.response.status) {
            case 404:
              this.store.commit('authError', 'Not logged in through okta')
              break
            case 500:
              this.store.commit('authError', 'Not registered in system')
              break
            default:
              this.store.commit('authError', 'Unknown error')
          }
        }
        this.router.push('/forbidden')
      })
  }

  public hasAnyAuthority (authorities: any): boolean {
    if (typeof authorities === 'string') {
      authorities = [authorities]
    }
    if (!this.authenticated || !this.userAuthorities) {
      return false
    }

    for (let index = 0; index < authorities.length; index++) {
      if (this.userAuthorities.includes(authorities[index])) {
        return true
      }
    }

    return false
  }

  public logout (): void {
    console.warn('TODO')
  }

  public get authenticated (): boolean {
    return this.store.getters.authenticated
  }

  public get userAuthorities (): any {
    return this.store.getters.account.authorities
  }
}
